import React from "react";
import { observer } from "mobx-react";

export default observer(function ChatErrorMessage() {
	return (
		<div>
			<span style={{ color: "#000000" }}> </span>
		</div>
	);
});
